import { z } from 'zod';

export const setClipTitleV1RequestSchema = z.object({
  title: z.string().min(1),
});

export type ISetClipTitleV1Request = z.infer<typeof setClipTitleV1RequestSchema>;
